/* eslint-disable camelcase */
import axios from 'axios';
import { MENU_INITIAL_RECOMMENDATION_ENDPOINT } from '@dynameat/constants';

export const recommendationListRequest = (menu__point_of_sale__guid) => axios.get(
  MENU_INITIAL_RECOMMENDATION_ENDPOINT(), { params: { menu__point_of_sale__guid, page_size: 0 } }
);

export const createRecommendationRequest = (recommendation) => axios.post(MENU_INITIAL_RECOMMENDATION_ENDPOINT(), recommendation, { headers: { 'content-type': 'multipart/form-data' } });

export const editRecommendationRequest = (recommendation__guid, recommendation) => axios.patch(MENU_INITIAL_RECOMMENDATION_ENDPOINT(recommendation__guid), recommendation, { headers: { 'content-type': 'multipart/form-data' } });

export const deleteRecommendationRequest = (recommendation__guid) => axios.delete(MENU_INITIAL_RECOMMENDATION_ENDPOINT(recommendation__guid));
